import { render, staticRenderFns } from "./ConfigList.vue?vue&type=template&id=202e83bb&scoped=true&lang=pug&"
import script from "./ConfigList.vue?vue&type=script&lang=js&"
export * from "./ConfigList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigList.scss?vue&type=style&index=0&id=202e83bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202e83bb",
  null
  
)

export default component.exports